export const splitLines = (data: string): string[] => data.split(/\r?\n/);
export const encodeBase64 = (data: string) =>
  Buffer.from(data).toString("base64");
export const decodeBase64 = (data: string) =>
  Buffer.from(data, "base64").toString("ascii");
